import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const merchantListStore = create(
  persist(
    (set) => ({
      merchantList: [],
      selectedMerchant: null,
      isFirstSelectedMerchant: true,

      setMerchantList: (newList) => set({ merchantList: newList }),

      setSelectedMerchant: (newSelectedMerchant) =>
        set({ selectedMerchant: newSelectedMerchant }),

      setIsFirstSelectedMerchant: (isFirstmerchant) =>
        set({ isFirstSelectedMerchant: isFirstmerchant }),
    }),
    {
      name: "merchantList-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default merchantListStore;
